import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedQuery from './AuthorizedQuery';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql(`
  query me {
    me {
      id
      isAnonymous
      firstName
      lastName
      email
    }
  }
`);

const UPDATE_MUTATION = gql(`
  mutation updateUser($params: UpdateUserInput!) {
    updateUser(params: $params) {
      id
      firstName
      lastName
      email
    }
  }
`);

export type UpdateUserFn = (firstName: string, lastName: string) => void;

interface Props {
  children: (
    user: User | null,
    loading: boolean,
    updateUser: UpdateUserFn | null,
    updating: boolean
  ) => React.ReactNode;
}

const UserProvider: React.StatelessComponent<Props> = (props: Props) => (
  <AuthorizedQuery query={GQL}>
    {({ data, loading }) => {
      if (!data || loading) {
        return props.children(null, true, null, false);
      }
      return (
        <AuthorizedMutation
          mutation={UPDATE_MUTATION}
        >
          {(mutateFn, result) => props.children(
            data.me,
            false,
            (firstName, lastName) => mutateFn({variables: {params: {firstName, lastName}}}),
            result.loading
          )}
        </AuthorizedMutation>
      );
    }}
  </AuthorizedQuery>
);

export default UserProvider;


// WEBPACK FOOTER //
// ./src/providers/UserProvider.tsx